import { replace } from "react-router-redux";
import { stringify } from "query-string";

import { getLocation, getPreviousLocation } from "./selectors";
import { CLEAR_PREVIOUS_LOCATION } from "./constants";
import { urlEncodeAllParamsButRefine } from "../../../helpers/urlEncodeAllParamsButRefine";

const filterObject = (obj, fn) => {
  const res = {};
  Object.keys(obj).forEach(key => {
    const value = obj[key];
    if (fn(key, value)) {
      res[key] = value;
    }
  });

  return res;
};

const emptyValues = [undefined, "", null];
const filterEmptyValues = obj =>
  filterObject(obj, (key, value) => !emptyValues.includes(value));

export const getCurrentQueryParams = () => getLocation().query;

export const merge = params => {
  const existingParams = getCurrentQueryParams();

  return Object.assign({}, existingParams, params);
};

export const buildLocationQuery = ({ query: params, hash }, preserve) => {
  const newParams = filterEmptyValues(preserve ? merge(params) : params);

  delete newParams.affid;
  const { pathname } = getLocation();

  const location = {
    pathname,
    search: `?${stringify(urlEncodeAllParamsButRefine(newParams), {
      encode: false
    })}`
  };

  if (hash) {
    location.hash = `#${hash}`;
  }

  return location;
};

export const updateLocationQuery = (query, preserve = true) =>
  replace(buildLocationQuery(query, preserve));

export const undoLocation = () => (dispatch, getState) => {
  const previousLocation = getPreviousLocation(getState());
  if (previousLocation) {
    dispatch(replace(previousLocation));
  }
  dispatch({ type: CLEAR_PREVIOUS_LOCATION });
};

export default updateLocationQuery;
